import { composeValidators, isBlockedDomain, isEmail, isRequired } from '../../utils/validate';

/**
 * Pre-composed validators for subscription forms
 * Provides consistent validation rules across all subscription components
 */

/**
 * Validator for subscription email field
 * Checks: required, not a blocked domain, valid email format
 */
export const subscriptionEmailValidator = composeValidators(isRequired, isBlockedDomain, isEmail);
